module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/csv-9c109cc18e1902f42b53f3a2d91b166c.svg";